export default __webpack_public_path__ + "static/media/Siege.41486a2d.jpg";